<template>
  <div class="row littelAlerts">
    <div class="col-xl-11">
      <ul v-if="filters.length" class="filert-lilter__list">
        <li v-for="item in filters" :key="`${item.filter}-${item.value}`" class="alert-filter__item">
          <div class="alert alert-success alert-dismissable">
            {{ getDataTitle(item.type, item.filter, item.value) }}
            <reset-button @click.native.once="setFilter(item.type, item.filter, item.value)" class="close closeAlerts" />
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {SEARCH, SET_FILTER, REMOVE_TABLE_FILTER} from '@/store/actions/search'
import {mapGetters} from 'vuex'

export default {
  name: 'filter-badges',
  props: {
    type: {
      type: String,
      require: true
    }
  },
  computed: {
    filters () {
      return [...this.getFiltersByType(this.type), ...this.getFiltersByType('static'), ...this.getFiltersByType('table')]
    },
    ...mapGetters(['getFilters', 'getDataTitle', 'getTableFilter'])
  },
  methods: {
    getFiltersByType (type) {
      return Object.entries(this.getFilters(type)).reduce((allFilters, [filter, values]) => ([
        ...allFilters,
        ...values.reduce((allValues, value) => ([
          ...allValues,
          { type, filter, value },
        ]), [])
      ]), [])
    },
    setFilter (type, filter, value) {
      this.$store.dispatch(SET_FILTER, { type, filter, value }).then(() => {
        if (type === 'table') {
          this.$store.dispatch(REMOVE_TABLE_FILTER, { filter }).then(() => {})
        }
        const { $router: router } = this
        this.$store.dispatch(SEARCH, { router })
      })
    }
  }
}
</script>
